import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { ToggleButtonGroup, ToggleButton } from '#component/device/devices-popup/styles';

const StyledAddIcon = styled(AddIcon)({
  fontSize: '1rem',
  marginRight: '.25rem'
});

const StyledEditIcon = styled(EditIcon)({
  fontSize: '1rem',
  marginRight: '.25rem'
});

const ToggleAddModeButton = ({ addMode, handleAddMode }) => {
  const [view, setView] = useState(() => (addMode ? 'add' : 'modify'));

  const handleViewChange = (event, nextView) => {
    if (nextView !== null) {
      setView(nextView);
      handleAddMode();
    }
  };

  return (
    <ToggleButtonGroup
      value={view}
      exclusive
      onChange={handleViewChange}
      aria-label="Add-Modify Toggle"
    >
      <ToggleButton value="add" aria-label="Add devices view">
        <StyledAddIcon />
        <span>Add</span>
      </ToggleButton>
      <ToggleButton value="modify" aria-label="Modify devices view">
        <StyledEditIcon />
        <span>Modify</span>
      </ToggleButton>
    </ToggleButtonGroup>);
};

export default ToggleAddModeButton;
